import React from 'react'

import Richtext from '@/atoms/RichText'
import Button from '@/atoms/Button'

import HeadingWithMark from '@/molecules/HeadingWithMark'

import { stripHtml } from 'utils/string'

import { StyledHeroContent } from './styles'

const HeroContent = ({
  title,
  description,
  cta
}) => {
  // If the description is the same as the title, don't render it
  const isDuplicateDescription = title && description && stripHtml(description) === title.trim()

  return (
    <StyledHeroContent>
      {
        title &&
        // Cannot render HeadingWithMark as header,
        // it's used in too many different places.
        // Will just wrap it here .
        <header>
          <HeadingWithMark as="h1" bold typo="heading1" content={title} />
        </header>
      }

      {
        description && !isDuplicateDescription &&
          <Richtext as="div" typo="paragraphLarge">
            {description}
          </Richtext>
      }
      {
        cta &&
        !!cta.link &&
        <Button general big
          className={cta.className}
          keyword={cta.keyword}
          {...cta.icon}
          {...cta.link}
          label={cta.link.title}/>
      }
    </StyledHeroContent>
  )
}

export default HeroContent
